// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2UGES","checkboxCol":"Table_checkboxCol__q-X0h","emailCol":"Table_emailCol__2_pZ8","actionCol":"Table_actionCol__3TylQ"};